import { createSlice } from "@reduxjs/toolkit";

export const tableOrderSlice = createSlice({
    name : 'tableorder',
    initialState : {
        language: {ko: true, en: false, 'zh-Hans': false, ja: false},
    },
    reducers : {
        setLanguage : ( state,action) => {
            state.language = action.payload
        },
    }
})

export const { setLanguage } = tableOrderSlice.actions

export default tableOrderSlice.reducer